import VpnLockOutlinedIcon from "@mui/icons-material/VpnLockOutlined";
import React from "react";
import { useOutsideAustraliaPopup } from "../../../services/app-state";
import { colors } from "../../../utils/colors";
import { Notification } from "../Notification";

export const OutsideAustraliaNotification = () => {
    const [{ isShowing }, { closeOutsideAuPopup }] = useOutsideAustraliaPopup();

    return (
        <Notification
            icon={
                <div style={{ marginBottom: 16 }}>
                    <VpnLockOutlinedIcon fontSize="large" htmlColor={colors.brandDark} />
                </div>
            }
            isVisible={isShowing}
            title={
                "It looks like you might be outside of Australia or using a Virtual Private Network (VPN)"
            }
            content={
                "Headstart uses your location to connect you with services near you. This data may be inaccurate based on your current location or device configuration."
            }
            onConfirm={closeOutsideAuPopup}
        />
    );
};
